import { render, staticRenderFns } from "./BoardItemsTable.vue?vue&type=template&id=cfcdbc76&"
import script from "./BoardItemsTable.vue?vue&type=script&lang=js&"
export * from "./BoardItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./BoardItemsTable.vue?vue&type=style&index=0&id=cfcdbc76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports